"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _NumberUtils = require("./NumberUtils");

var _DiffLoaderUI = require("./DiffLoaderUI.js");

var jquery = require("jquery");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var SERVER = "localhost"; //const SERVER = "192.168.121.113";

var DEFAULT_OPTS = {
  server: SERVER,
  restBaseurl: null,
  // mandatory
  pathsToSkip: null,
  jsessionidRecoverHandler: null,
  loadHandler: null,
  endloadHandler: null,
  errorHandler: null,
  doLogoutHandler: null,
  useStub: true,
  // TODO settare come isDev
  serveridRecoverHandler: null,
  sessionConf: {
    sessionExpiredHandler: null,
    sessionExpiredHandlerTimeout: null
  },
  stringConversationId: "conversationId"
};
var sessionExpiredHandlerId = null; // class WebRest {

/**
 * @class
 * @classdesc Armundia REST communication.
 * create a (singleton) WebRest to use inside a SPA.
 * @constructor
 * 
 * @param {string} server_or_options server domain, i.e. localhost, 192.168.121.113, privatebank.intesasanpaolo.ch -
 *  if omitted, became 'localhost'
 * OR you can use this ONE parameter as object contains all parameters described below
 * 
 * @param {string} restBaseurl base url, fully qualified url, i.e. https://localhost:9000/rest/  - MANDATORY
 * @param {string[]} pathsToSkip array of paths (string) will be skipped can be null
 * @param {function} jsessionidRecoverHandler handler (function) to get jsessionid when WebRest needs. function must return jsessionid or null
 * @param {function} loadHandler handler (function) to signal when WebRest in in loading
 * @param {function} endloadHandler handler (function) to signal when WebRest end loading (in error or not)
 * @param {function} errorHandler handler (function) to handle error message (passed as parameter)
 * @param {function} doLogoutHandler handler (function) to signal needs to execute logout
 * @param {string} useStub activate handling of file stubs (with path starts with string passed)
 * @param {string} serveridRecoverHandler handler (function) to get serverid when WebRest needs. function must return serverid or null
 * @param {obj} sessionConf session configuration formed by @param {function} sessionExpiredHandler and @param {function} sessionExpiredHandlerTimeout; sessionExpiredHandler is called after sessionExpiredHandlerTimeout minutes
 * @param {string} stringConversationId string for configuring 'conversationId' as string at url forming
 */

function WebRest(server, restBaseurl, pathsToSkip, jsessionidRecoverHandler, loadHandler, endloadHandler, errorHandler, doLogoutHandler, useStub, serveridRecoverHandler, sessionConf, stringConversationId) {
  if (_typeof(server) === 'object') {
    var opts = (0, _lodash.extend)(DEFAULT_OPTS, server);
    this.server = opts.server;
    restBaseurl = opts.restBaseurl;
    pathsToSkip = opts.pathsToSkip;
    jsessionidRecoverHandler = opts.jsessionidRecoverHandler;
    loadHandler = opts.loadHandler;
    endloadHandler = opts.endloadHandler;
    errorHandler = opts.errorHandler;
    doLogoutHandler = opts.doLogoutHandler;
    useStub = opts.useStub;
    serveridRecoverHandler = opts.serveridRecoverHandler;
    sessionConf = opts.sessionConf;

    if (sessionConf) {
      sessionConf.sessionExpiredHandlerTimeout = _NumberUtils.default.convertMinutesInMilliseconds(sessionConf.sessionExpiredHandlerTimeout);
    }

    stringConversationId = opts.stringConversationId;
  } else if (typeof server === 'string') {
    if (!server) {
      server = SERVER;
    }

    this.server = server;
  }

  if (restBaseurl === null || restBaseurl === undefined) {
    throw new Error("try to instance WebRest without restBaseurl parameter");
  }

  if (useStub === undefined) useStub = null;
  this.restBaseurl = restBaseurl;
  this.pathsToSkip = pathsToSkip;
  this.jessionidRecoverHandler = jsessionidRecoverHandler;
  this.loadHandler = loadHandler;
  this.endloadHandler = endloadHandler;
  this.errorHandler = errorHandler;
  this.doLogoutHandler = doLogoutHandler;
  this.useStub = useStub;
  this.serveridRecoverHandler = serveridRecoverHandler;
  this.sessionConf = sessionConf;
  this.diffLoaderUI = new _DiffLoaderUI.default();

  if (stringConversationId) {
    this.stringConversationId = stringConversationId;
  } // this.loadHandler = this.loadHandler.bind(this);
  // this.endloadHandler = this.endloadHandler.bind(this);

}
/**
 * @returns {String} The actual JSessionId
 */


WebRest.prototype.getJsessionid = function () {
  var jid = null;

  if (this.jessionidRecoverHandler) {
    var j = this.jessionidRecoverHandler();
    if (j) jid = j;
  }

  return jid;
};
/**
 * @returns {String} The actual server ID
 */


WebRest.prototype.getServerId = function () {
  var serverId = null;

  if (this.serveridRecoverHandler) {
    var j = this.serveridRecoverHandler();
    if (j) serverId = j;
  }

  return serverId;
};
/**
 * @returns {String} Application base URL
 */


WebRest.prototype.getBaseUrl = function () {
  return this.restBaseurl;
};
/**
 * @returns {String} Actual conversation ID opened
 */


WebRest.prototype.getStringConversationId = function () {
  return this.stringConversationId;
};
/**
 * Create Rest link from the path and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} options Object with the options to be passed
 * @param {*} toSkip 
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.createRestLink = function (path, options, toSkip) {
  var url;
  var jsessionid = null;

  if (this.useStub && path.startsWith(this.useStub)) {
    url = path;
  } else {
    jsessionid = this.getJsessionid();
    url = this.restBaseurl + path;
  }

  if (jsessionid !== null && window.location.hostname === this.server) {
    // this.server
    var skip = false;

    if (toSkip) {
      for (var i = 0; i < toSkip.length; i++) {
        var psk = toSkip[i];

        if (psk === path) {
          skip = true;
          break;
        }
      }
    }

    if (!skip) {
      var ind = url.indexOf('?');

      if (ind === -1) {
        url = url + ";jsessionid=" + jsessionid;
      } else {
        var preurl = url.substring(0, ind);
        var posturl = url.substring(ind, url.length);
        url = preurl + ";jsessionid=" + jsessionid + posturl;
      }
    }
  }

  if (options && options['conversationId']) {
    var _ind = url.indexOf('?');

    if (_ind === -1) {
      url = url + "?" + this.stringConversationId + "=" + options['conversationId'];
    } else {
      url = url + "&" + this.stringConversationId + "=" + options['conversationId'];
    }
  }

  return url;
};
/**
 * Make a POST call to the server with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.post = function (path, body, dispatch, options) {
  var _this = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.post: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options);
  console.log("[WebRest.post]: " + url, body);
  var temp = null;

  if (body !== null) {
    try {
      temp = JSON.stringify(body);
    } catch (e) {
      console.error("errore stringify body for", body);
      console.error(e);
      return {};
    }
  }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/json; charset=utf-8',
    dataType: "json" //dataType: The type of data that you're expecting back from the server

  }, options);

  this._loading(url, dispatch, opts);

  return jquery.ajax({
    url: url,
    data: temp,
    cache: false,
    dataType: opts.dataType,
    contentType: opts.contentType,
    type: "POST",
    headers: {
      'SERVER-ID': this.getServerId()
    }
  }).then(function (data) {
    console.log("[WebRest.post] ok url:" + url, data);

    _this._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    console.log("[WebRest.post] reject url:" + url, reject);

    _this._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep);
        return reject.responseText;
      }
    } else if (reject.status === 405) {
      // Ritento nuovamente la chiamata
      if (!options) options = {};
      if (!options.count) options.count = 0;

      if (options.count < 4) {
        options.count = options.count + 1;
        return post(path, body, dispatch, options);
      }
    }

    _this._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Make a GET call to the server with the path and options passed 
 * @param {String} path URL for the call to be made
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.get = function (path, dispatch, options) {
  return this.get(path, null, dispatch, options);
};
/**
 * Make a GET call to the server with the path and options passed 
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the GET call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.get = function (path, body, dispatch, options) {
  var _this2 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.get: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options);
  console.log("[WebRest.get]: " + url, body);
  var temp = null; // if (body !== null) {
  //     try {
  //         temp = JSON.stringify(body);
  //     } catch (e) {
  //         console.error("errore stringify body for", url, body);
  //         console.error(e);
  //         return {};
  //     }
  // }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/json; charset=utf-8',
    dataType: "json" //dataType: The type of data that you're expecting back from the server

  }, options);

  this._loading(url, dispatch, opts);

  return jquery.ajax({
    url: url,
    cache: false,
    data: temp,
    dataType: opts.dataType,
    contentType: opts.contentType,
    headers: {
      'SERVER-ID': this.getServerId()
    },
    type: "GET"
  }).then(function (data) {
    console.log("[WebRest.get] ok url:" + url, data);

    _this2._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    _this2._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep);
        return reject.responseText;
      }
    }

    console.warn("[WebRest.get] reject url:" + url, reject);

    _this2._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Make a POST FORM call to the server with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST FORM call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.postForm = function (path, body, dispatch, options) {
  var _this3 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.postForm: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options, this.pathsToSkip);
  console.log("[WebRest.postForm]: " + url);
  var temp = null;

  if (body !== null) {
    if (body instanceof FormData) {
      temp = body;
    } else {
      temp = jquery.param(body);
    }
  }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    processData: true,
    dataType: "json" //dataType: The type of data that you're expecting back from the server

  }, options);

  this._loading(url, dispatch, opts);

  return jquery.ajax({
    url: url,
    type: "POST",
    cache: opts.cache,
    data: temp,
    dataType: opts.dataType,
    processData: opts.processData,
    contentType: opts.contentType,
    headers: {
      'SERVER-ID': this.getServerId()
    }
  }).then(function (data) {
    console.log("[WebRest.postForm] ok url:" + url, data);

    _this3._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    console.log("[WebRest.postForm] reject url:" + url, reject);

    _this3._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep, reject);
        return reject.responseText;
      }
    } else if (reject.status === 405) {
      // Ritento nuovamente la chiamata
      if (!options.count) options.count = 0;

      if (options.count < 4) {
        options.count = options.count + 1;
        return postForm(path, body, dispatch, options);
      }
    }

    _this3._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Download a File from a POST FORM call made with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFilePojo = function (path, body, dispatch, options) {
  var _this4 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFilePojo: cannot have path parameter null/undefined");
    return {};
  } //il servizio Rest deve restituire un FilePojo


  return this.postForm(path, body, dispatch, options).then(function (resolve) {
    console.log('\t downloadFilePojo: resolve');

    _this4._resolveFilePojo(resolve);

    return resolve;
  }, function (reject) {
    console.log('\t downloadFilePojo: reject');
    return reject;
  });
};
/**
 * Download a File from a POST call made with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFilePojoPost = function (path, body, dispatch, options) {
  var _this5 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFilePojoPost: cannot have path parameter null/undefined");
    return {};
  } //il servizio Rest deve restituire un FilePojo


  return this.post(path, body, dispatch, options).then(function (resolve) {
    console.log('\t downloadFilePojoPost: resolve');

    _this5._resolveFilePojo(resolvem);

    return resolve;
  }, function (reject) {
    console.log('\t downloadFilePojoPost: reject');
    return reject;
  });
};
/**
 * 
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFileStreamPOST = function (path, body, dispatch, options) {
  var _this6 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFileStreamPOST: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options, this.pathsToSkip);
  console.log("[WebRest.downloadFileStreamPOST]: " + url);
  var temp = null;

  if (body !== null) {
    if (body instanceof FormData) {
      temp = body;
    } else {
      temp = jquery.param(body);
    }
  }

  var opts = Object.assign({}, {
    contentType: 'application/x-www-form-urlencoded; charset=utf-8'
  }, options);

  this._loading(url, dispatch, opts); // Use XMLHttpRequest instead of Jquery jqueryajax


  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    console.log("[WebRest.downloadFileStreamPOST] onreadystatechange " + xhr.readyState);

    if (xhr.readyState === 4 && xhr.status === 200) {
      var contentType = xhr.getResponseHeader("Content-Type");
      console.log("[WebRest.downloadFileStreamPOST] contentType: " + contentType);
      var contentDisposition = xhr.getResponseHeader("Content-Disposition");
      console.log("[WebRest.downloadFileStreamPOST] contentDisposition: " + contentDisposition);

      var fileName = _this6._getFileNameByContentDisposition(contentDisposition); // Trick for making downloadable link


      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(xhr.response); // Give filename you wish to download

      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click(); //remove the link when done

      document.body.removeChild(link);
    }
  };

  xhr.onloadend = function () {
    console.log("[WebRest.downloadFileStreamPOST] onloadend "); //The loadend event is fired when a request has completed, whether successfully (after load) or unsuccessfully (after abort or error).

    _this6._endload(url, dispatch, options);
  }; // Post data to URL which handles post request


  xhr.open("POST", url);
  xhr.setRequestHeader("Content-Type", opts.contentType); // You should set responseType as blob for binary responses

  xhr.responseType = 'blob';
  xhr.send(temp);
  return Promise.resolve();
};
/**
 * 
 * @param {*} path URL for the call to be made
 * @param {*} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFileStreamGET = function (path, options) {
  if (path === undefined || path === null) {
    console.error("WebRest.downloadFileStreamGET: cannot have path parameter null/undefined");
    return {};
  }

  console.log("[WebRest.downloadFileStreamGET]: " + path);
  var link = document.createElement('a'); //link.download = "nomeFile.pdf";

  link.href = this.createRestLink(path, options);
  link.target = "_blank";
  document.body.appendChild(link);
  link.click(); //remove the link when done

  document.body.removeChild(link);
  return Promise.resolve();
};

WebRest.prototype._getFileNameByContentDisposition = function (contentDisposition) {
  var regex = /filename[^;=\n]*=(UTF-8(['"]*))?(.*)/;
  var matches = regex.exec(contentDisposition);
  var filename;

  if (matches !== null && matches[3]) {
    filename = matches[3].replace(/['"]/g, '');
  }

  return decodeURI(filename);
}.bind(void 0);

WebRest.prototype._resolveFilePojo = function (resolve) {
  var mimeType = "application/octet-stream";

  if (resolve.mimeType) {
    console.log("mimeType: " + resolve.mimeType);
    mimeType = resolve.mimeType;
  }

  var msie = window.navigator.userAgent.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer
    {
      console.log("Browser Internet Explorer");

      var blob = this._b64toBlob(resolve.contentBase64, mimeType);

      window.navigator.msSaveOrOpenBlob(blob, resolve.name);
    } else {
    var link = document.createElement('a');
    link.download = resolve.name;
    link.href = "data:" + mimeType + ";base64," + resolve.contentBase64;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click(); //remove the link when done

    document.body.removeChild(link); //window.open("data:" + mimeType + ";base64, " + resolve.contentBase64, resolve.name);
  }
};

WebRest.prototype._b64toBlob = function (b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
};

WebRest.prototype._loading = function (url, dispatch, options) {
  if (!dispatch) return;
  if (options && options.loading !== null && options.loading !== undefined && !options.loading) return;
  var lh = options && options.loadHandler || this.loadHandler;
  if (!lh) return;
  this.diffLoaderUI.load(url, lh, dispatch, options);
};

WebRest.prototype._endload = function (url, dispatch, options) {
  if (!dispatch) return;
  if (options && options.loading !== null && options.loading !== undefined && !options.loading) return;
  var eh = options && options.endloadHandler || this.endloadHandler;
  if (!eh) return;
  this.diffLoaderUI.endload(url, eh, dispatch, options);
};

WebRest.prototype._inError = function (dispatch, mesg, statusCode, options, stacktrace) {
  console.warn('WebRest error:', mesg, stacktrace, " - status code:", statusCode);
  if (!dispatch || !this.errorHandler) return;
  var eh = options && options.errorHandler || this.errorHandler;
  eh(dispatch, mesg, statusCode, options, stacktrace);
};

WebRest.prototype._handleError = function (dispatch, reject, options) {
  var message = null;
  var stacktrace = null;

  if (reject.responseJSON && reject.responseJSON.message) {
    message = reject.responseJSON.message;
    stacktrace = reject.responseJSON.stackTrace;
  } else {
    message = this._getAjaxErrorMessage(reject);
    if (reject.responseText && reject.responseText.indexOf("<html") >= 0) stacktrace = reject.responseText;
  }

  if (reject.status === 401 || reject.status === 400) {
    console.log("[WebRest] errore 400/401");
  } else if (reject.status === 403) {
    console.log("[WebRest] sessione scaduta (faccio logout prima del messaggio)");

    this._logout(dispatch);
  }

  this._inError(dispatch, message, reject.status, options, stacktrace);
};

WebRest.prototype._logout = function (dispatch) {
  if (dispatch && this.doLogoutHandler) this.doLogoutHandler(dispatch);
};

WebRest.prototype._getAjaxErrorMessage = function (reject) {
  console.log("getAjaxErrorMessage", reject);
  var message = "unknown error";

  if (reject) {
    console.log("Request Failed: " + reject.statusText + ", " + reject.responseJSON + ' ' + reject.status);

    if (reject.readyState === 4) {
      // HTTP error (can be checked by XMLHttpRequest.status and XMLHttpRequest.statusText)
      message = reject.status + " - " + reject.statusText;
    } else if (reject.readyState === 0) {
      message = "Network connection error";
    } else {
      message = reject.status + " - " + reject.statusText;
    }
  }

  return message;
};

WebRest.prototype._resetExpiredSessionHandler = function (dispatch, options) {
  var sessionConf = this.sessionConf;

  if (options && options.skipResetSession) {
    return;
  }

  if (sessionConf && dispatch) {
    var sessionExpiredHandler = sessionConf.sessionExpiredHandler;
    var sessionExpiredHandlerTimeout = sessionConf.sessionExpiredHandlerTimeout;

    if (sessionExpiredHandler && sessionExpiredHandlerTimeout && sessionExpiredHandlerTimeout > 0) {
      if (sessionExpiredHandlerId) {
        clearTimeout(sessionExpiredHandlerId);
      }

      sessionExpiredHandlerId = setTimeout(function () {
        sessionExpiredHandler(dispatch);
      }, sessionExpiredHandlerTimeout);
    }
  }
};

var _default = WebRest;
exports.default = _default;